let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("dfcLI")).then(() => parcelRequire('3SsKb'));